"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValuelessTableFilterOperation = exports.TABLE_FILTER_VALUELESS_OPERATIONS = exports.TABLE_FILTER_OPERATIONS_BY_KIND = exports.TableFilterValueKind = exports.TableFilterOperation = void 0;
var TableFilterOperation;
(function (TableFilterOperation) {
    TableFilterOperation["Contains"] = "contains";
    TableFilterOperation["DoesNotContain"] = "doesNotContain";
    TableFilterOperation["Is"] = "is";
    TableFilterOperation["IsNot"] = "isNot";
    TableFilterOperation["IsIn"] = "isIn";
    TableFilterOperation["IsOn"] = "isOn";
    TableFilterOperation["IsNotOn"] = "isNotOn";
    TableFilterOperation["IsAfter"] = "isAfter";
    TableFilterOperation["IsBefore"] = "isBefore";
    TableFilterOperation["IsMoreThan"] = "isMoreThan";
    TableFilterOperation["IsLessThan"] = "isLessThan";
    TableFilterOperation["IsBetween"] = "isBetween";
    TableFilterOperation["IsChecked"] = "isChecked";
    TableFilterOperation["IsNotChecked"] = "isNotChecked";
    TableFilterOperation["IsKnown"] = "isKnown";
    TableFilterOperation["IsUnknown"] = "isUnknown";
})(TableFilterOperation || (exports.TableFilterOperation = TableFilterOperation = {}));
var TableFilterValueKind;
(function (TableFilterValueKind) {
    TableFilterValueKind["Text"] = "text";
    TableFilterValueKind["Number"] = "number";
    TableFilterValueKind["Date"] = "date";
    TableFilterValueKind["Checkbox"] = "checkbox";
    TableFilterValueKind["Select"] = "select";
})(TableFilterValueKind || (exports.TableFilterValueKind = TableFilterValueKind = {}));
const TEXT_OPERATIONS = [
    TableFilterOperation.Contains,
    TableFilterOperation.DoesNotContain,
    TableFilterOperation.Is,
    TableFilterOperation.IsNot,
    TableFilterOperation.IsKnown,
    TableFilterOperation.IsUnknown,
];
const NUMBER_OPERATIONS = [
    TableFilterOperation.IsBetween,
    TableFilterOperation.Is,
    TableFilterOperation.IsNot,
    TableFilterOperation.IsMoreThan,
    TableFilterOperation.IsLessThan,
    TableFilterOperation.IsKnown,
    TableFilterOperation.IsUnknown,
];
const DATE_OPERATIONS = [
    TableFilterOperation.IsBetween,
    TableFilterOperation.IsOn,
    TableFilterOperation.IsNotOn,
    TableFilterOperation.IsAfter,
    TableFilterOperation.IsBefore,
    TableFilterOperation.IsKnown,
    TableFilterOperation.IsUnknown,
];
const CHECKBOX_OPERATIONS = [TableFilterOperation.IsChecked, TableFilterOperation.IsNotChecked];
const SELECT_OPERATIONS = [
    TableFilterOperation.IsIn,
    TableFilterOperation.IsNot,
    TableFilterOperation.IsKnown,
    TableFilterOperation.IsUnknown,
];
exports.TABLE_FILTER_OPERATIONS_BY_KIND = {
    [TableFilterValueKind.Text]: TEXT_OPERATIONS,
    [TableFilterValueKind.Number]: NUMBER_OPERATIONS,
    [TableFilterValueKind.Date]: DATE_OPERATIONS,
    [TableFilterValueKind.Checkbox]: CHECKBOX_OPERATIONS,
    [TableFilterValueKind.Select]: SELECT_OPERATIONS,
};
exports.TABLE_FILTER_VALUELESS_OPERATIONS = [
    TableFilterOperation.IsKnown,
    TableFilterOperation.IsUnknown,
    TableFilterOperation.IsChecked,
    TableFilterOperation.IsNotChecked,
];
const isValuelessTableFilterOperation = (operation) => exports.TABLE_FILTER_VALUELESS_OPERATIONS.includes(operation);
exports.isValuelessTableFilterOperation = isValuelessTableFilterOperation;
